<template>
<!--  <div class="d-grid gap-2 col-md-6 col-xl-8 mx-auto">-->
  <div class="d-grid gap-2">
      <a class="btn btn-block" :href=loginUrl>
          <img class="apple-icon" :src="`${$imagePathBase}logos/apple-logo.svg`"/>
          <span v-if="createAccount" class="apple-text">Sign Up with Apple</span>
          <span v-else class="apple-text">Sign In with Apple</span>
      </a>
  </div>
</template>


<script>
import { defineComponent } from 'vue'
import {userStore} from "@/userStore";

export default defineComponent({
  // eslint-disable-next-line
  name: "Apple", // should have a multi-word name
  props: ['createAccount'],
  emits: ['user-updated'],
  computed: {
    user() {
      return userStore.user;
    },

    loginUrl() {
      const urlObject = new URL(`${window.location.origin}/api/auth/login/apple`);
      for (const key in this.$route.query) {

        //if (this.$route.query.hasOwnProperty(key)) {
        if (Object.hasOwn(this.$route.query, key)) {
          urlObject.searchParams.append(key, this.$route.query[key]);
        }
      }
      return urlObject.toString();
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
});
</script>


<style scoped>

.row {
  margin-top: 50px;
}

.btn {
  background-color: white;
  border: solid;
  border-width: 1px;
  border-color: black;

  &:hover {
    border: solid;
    border-width: 1px;
    border-color: black;
  }
}

.apple-text {
  color: black;
}

.apple-icon {
  padding-right: 10px;
  height: 20px;
  margin-top: -2px;
}
</style>